var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.987,
    height: 77.983,
    viewBox: "0 0 76.987 77.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_723",
    "data-name": "Groupe 723",
    transform: "translate(-543.573 -765.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_722",
    "data-name": "Groupe 722",
    transform: "translate(543.573 765.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2156",
    "data-name": "Trac\\xE9 2156",
    d: "M621.2,874.242a.726.726,0,0,1-.726-.726V825.733a.726.726,0,1,1,1.452,0v47.783A.726.726,0,0,1,621.2,874.242Z",
    transform: "translate(-583.265 -796.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2157",
    "data-name": "Trac\\xE9 2157",
    d: "M621.2,909.625a.726.726,0,0,1-.259-1.4l38.323-14.61a.726.726,0,0,1,.517,1.356l-38.323,14.61A.717.717,0,0,1,621.2,909.625Z",
    transform: "translate(-583.265 -831.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2158",
    "data-name": "Trac\\xE9 2158",
    d: "M621.2,812.437a.726.726,0,0,1-.241-1.411l38.046-13.389a.726.726,0,1,1,.482,1.369L621.444,812.4A.736.736,0,0,1,621.2,812.437Z",
    transform: "translate(-583.265 -782.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2159",
    "data-name": "Trac\\xE9 2159",
    d: "M700.4,845.484a.726.726,0,0,1-.726-.726V798.322a.726.726,0,1,1,1.452,0v46.436A.726.726,0,0,1,700.4,845.484Z",
    transform: "translate(-624.142 -782.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2160",
    "data-name": "Trac\\xE9 2160",
    d: "M581.512,811.6a.728.728,0,0,1-.259-.048l-37.212-14.174a.726.726,0,0,1,.517-1.356L581.77,810.2a.726.726,0,0,1-.258,1.4Z",
    transform: "translate(-543.573 -781.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2161",
    "data-name": "Trac\\xE9 2161",
    d: "M581.758,909.625a.716.716,0,0,1-.267-.051l-36.981-14.61a.726.726,0,1,1,.533-1.35l36.98,14.61a.726.726,0,0,1-.266,1.4Z",
    transform: "translate(-543.82 -831.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2162",
    "data-name": "Trac\\xE9 2162",
    d: "M544.3,844.647a.726.726,0,0,1-.726-.726V796.7a.726.726,0,1,1,1.452,0v47.221A.726.726,0,0,1,544.3,844.647Z",
    transform: "translate(-543.573 -781.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2163",
    "data-name": "Trac\\xE9 2163",
    d: "M544.3,781.747a.726.726,0,0,1-.267-1.4l37.213-14.7a.726.726,0,0,1,.533,1.351l-37.212,14.7A.728.728,0,0,1,544.3,781.747Z",
    transform: "translate(-543.573 -765.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2164",
    "data-name": "Trac\\xE9 2164",
    d: "M659.526,782.532a.718.718,0,0,1-.271-.053L620.931,767a.726.726,0,0,1,.543-1.346L659.8,781.133a.726.726,0,0,1-.272,1.4Z",
    transform: "translate(-583.265 -765.596)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2165",
    "data-name": "Trac\\xE9 2165",
    d: "M572.316,819.179a.726.726,0,0,1-.726-.726v-9.835a.726.726,0,0,1,1.452,0v9.835A.726.726,0,0,1,572.316,819.179Z",
    transform: "translate(-14.46 -21.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2166",
    "data-name": "Trac\\xE9 2166",
    d: "M593.1,826.434a.726.726,0,0,1-.726-.726V815.29a.726.726,0,0,1,1.452,0v10.418A.726.726,0,0,1,593.1,826.434Z",
    transform: "translate(-25.189 -25.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2167",
    "data-name": "Trac\\xE9 2167",
    d: "M582.374,833.481a.725.725,0,0,1-.257-.047l-10.059-3.812a.726.726,0,1,1,.514-1.357l10.059,3.812a.726.726,0,0,1-.257,1.4Z",
    transform: "translate(-14.46 -32.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2168",
    "data-name": "Trac\\xE9 2168",
    d: "M572.315,793.171a.726.726,0,0,1-.263-1.4l36.008-13.994a.726.726,0,0,1,.526,1.353l-36.008,13.994A.726.726,0,0,1,572.315,793.171Z",
    transform: "translate(-14.46 -6.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2169",
    "data-name": "Trac\\xE9 2169",
    d: "M593.1,801.2a.726.726,0,0,1-.255-1.405L629.8,785.911a.726.726,0,0,1,.51,1.359l-36.954,13.887A.724.724,0,0,1,593.1,801.2Z",
    transform: "translate(-25.189 -10.461)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.4f5fd35115cfbf5470d77818c35dd8ee.svg";
export { ForwardRef as ReactComponent };